import { useEffect, useRef, useState } from "react"
import MainContentWrapper from "../../../Components/MainContentWrapper"
import { getCrmleads } from "../../../apis/BhuMeetTeams/Crm/leads"
import TableView from "../../../ReusableComponents/TableView/TableView"
import { Button } from "../../../Components/Helper"
import { useNavigate } from "react-router"
import DurationFilters from "../../../features/Revenue/SubComponents/DurationFilters"
import IssueDashboardFilter from "../../Operations/RequestIssue/issueDashboardFilter"
import dateFormat from "dateformat";
import { CreateCampaign } from "./createCampaign"
import Loading from "../../../ReusableFunctions/Loader"
import { getAllCampaigns } from "../../../apis/adminAPIs/teams"
import Popup from "../../../ReusableFunctions/Popup"

export const AllCampaign = () => {
    const navigate = useNavigate()
    const [campaigns, setCampaigns] = useState([])
    const [selectedLead, setSelectedLead] = useState()
    const [filter, setFilters] = useState(()=>{
        const getFilters =  localStorage.getItem("CRMCampaignsFilters");
        return getFilters ? JSON.parse(getFilters) : {
            fromDate: null,
            toDate: null,
            pageSize: 15,
            pageNumber: 1,
            interval:'all'
        }
    })
    const [openform, setOpenForm] = useState(false)
    const [loading, setloading] = useState(false)
    const [openFilter, setOpenFilter] = useState(false)
    const [formattedDate, setFormattedDate] = useState()
    const [selectedCampaign, setselectedCampaign] = useState(null)

    useEffect(() => {
        getAllCampaignsFunc(filter)
        // localStorage.setItem("CRMCampaignsFilters",JSON.stringify(filter));
    }, [filter.pageNumber,filter.pageSize,filter.fromDate,filter.toDate])

    const getAllCampaignsFunc=async({pageNumber,pageSize,fromDate,toDate})=>{
        try{
        Loading.set(true);
        let {campaigns}=await getAllCampaigns(pageNumber,pageSize,fromDate,toDate);
        console.log("campaigns",campaigns);
        setCampaigns(campaigns);
        }catch(err){
         console.log("err:",err);
         Popup.alert("ERROR","Something went wrong while getting campaigns","ERROR");
        }finally{
            Loading.set(false);
        }
    }



    return <MainContentWrapper header={"Campaign" + ` (${campaigns[0]?.total_campaigns || 0})`} rightContent={
        (<>
            <div style={{ display: "flex", gap: "10px" }}>
            <Button style={{ whiteSpace: "nowrap", height: "30px" }} text="Create" onClick={() => setOpenForm(true)} className="btn-large" />
            
            </div>
        </>
        )
    }>
        {openform && <CreateCampaign existingCampaign={selectedCampaign} open={openform} 
        onClose={() => { 
            setOpenForm(false); 
            setselectedCampaign(null);
            getAllCampaignsFunc(filter);
            }} 
        />}

        <div style={{display:"flex",marginBottom:"5px"}}>
            <div style={{ marginLeft: "10px", marginTop: "4px" }} className="date_section">
                <span>{formattedDate}</span>
            </div>

        </div>

        {openFilter && 
        <IssueDashboardFilter open={openFilter} onFilterChange={(e) => {
            console.log(e)

            setFilters((prev) => ({ ...prev, fromDate: e.fromDate, toDate: e.toDate, interval: !e.fromDate || !e.toDate ? e.interval || filter.interval : "custom",currentPage:1 }))
            setOpenFilter(false)
        }}
            filter={filter}
            onClose={(e) => {
                console.log(e)
                if (!filter.fromDate || !filter.toDate) {
                    console.log("ALL")
                    setFilters((prev) => ({ ...prev, interval: "all" }))
                    setFormattedDate('')
                }

                setOpenFilter(false)
            }} />
        }
        
        <TableView
            showSrNo={true}
            onStateChange={async (changedState) => {
                const { pageNumber } = changedState;
                  setFilters({ ...filter, pageNumber: pageNumber })
            }}
            onClickRow={ (row) => {
            setselectedCampaign(row);
            setOpenForm(true);
            } }

            isLoading={loading}
            loaderHeight={"500px"}
            columns={[
                { Header: "Name", accessor: "name", width: "15%" },
                { Header: "Source", accessor: "type", width: "15%" },
                { Header: "State", accessor: "state", width: "15%" },
                { Header: "Max Limit", accessor: "maxLimit", width: "10%" },
                { Header: "Status", accessor: "status", width: "10%" },
                { Header: "Created", accessor: "created", isDate: true, width: "15%" },
            ]}
            data={campaigns.map((c)=>({
                ...c,
                state:c.filter?.state,
                district:c.filter?.district,
                taluka:c.filter?.taluka,
                maxLimit:c.filter?.maxLimit,
                type:c?.type === "Auto_IVR" ? "Auto IVR" : c.type
            }))}
            pageNumber={filter.pageNumber ?? 1}
            pageSize={filter?.pageSize}
            count={Number(campaigns[0]?.total_campaigns) || 0}
        //   activities={{ onClickEdit: (lead) => {console.log(lead);setSelectedLead(lead);setOpenForm(true)},isEdit:true}}
        />



    </MainContentWrapper>

}